import classnames from "classnames";
import React from "react";
import { useTranslation } from "react-i18next";
import GenericButton from "../GenericButton/GenericButton";
import CashoutValueDto from "../../services/CashoutValueDto";

// tslint:disable-next-line:no-var-requires
const styles = require("./CashoutButton.scss");

export interface CashoutButtonProps {
    readonly children?: string;
    readonly className?: string;
    readonly cashoutValue?: number;
    readonly currentTimestamp?: number;
    readonly isBlocked?: boolean;
    readonly isError?: boolean;
    cashoutHandler(cashoutValueDto: CashoutValueDto): void;
}

export function CashoutButton({
    cashoutHandler,
    isBlocked,
    cashoutValue,
    ...props
}: CashoutButtonProps) {
    const disabled = !cashoutValue || isBlocked;
    const { t } = useTranslation("cashout");
    return (
        <div className={classnames(props.className, styles.wrapper)}>
            <GenericButton
                onClick={cashoutHandler}
                className={styles.button}
                disabled={disabled}
            >
                {disabled ? t("CashoutBlocked") : props.children}
            </GenericButton>
        </div>
    );
}
